import { createContext } from 'react';

import { TPrototypeDto } from '@app-velocity/av-api-v2';

export type ScenarioDetailsContextType = {
  scenario: TPrototypeDto;
};

export const ScenarioDetailsContext = createContext<ScenarioDetailsContextType>(
  {
    scenario: {},
  }
);
